import { BackdropVariant } from "./Backdrop.types";

export function backdropVariantFrom(variant?: any): BackdropVariant {
  switch (variant) {
    case BackdropVariant.AUTH:
      return BackdropVariant.AUTH;
    case BackdropVariant.DEFAULT:
    default:
      return BackdropVariant.DEFAULT;
  }
}
